<script lang="ts">
  import {slide} from 'svelte/transition';
  import InlineSVG from 'svelte-inline-svg';

  import crossIcon from '../../assets/icons/cross.svg';

  import IconButton from '../icon-button/IconButton.svelte';

  export let expanded: boolean = true;
</script>

<style lang="postcss">
  .container {
    position: relative;
    width: 100%;
  }

  .expanded {
    background-color: var(--ubilabs-expansion-panel-expanded-background-color);
  }

  .collapsed {
    background-color: var(--ubilabs-expansion-panel-collapsed-background-color);
  }

  .content {
    padding: 0.5rem 1rem;
    transition: height var(--ubilabs-expansion-panel-transition-duration)
      var(--ubilabs-expansion-panel-transition-timing-function);
  }

  :global(button.collapseButton) {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5rem;
  }
</style>

<section
  class="container {expanded ? 'expanded' : 'collapsed'} {$$props.class}">
  {#if expanded}
    <div class="content" transition:slide|local>
      <slot />

      <IconButton
        class="collapseButton"
        title="Close panel"
        aria-label="Close panel"
        on:click={() => (expanded = false)}>
        <InlineSVG src={crossIcon} />
      </IconButton>
    </div>
  {/if}
</section>
